import { IItemDataForAnalytics } from 'src/explore/types/shoppe';

// window.dataLayer only exists on whitelabel pages whose merchant has a GTM container. A push
// without an event only updates GTM's data model, so this names one a tag can fire on.
const identifyCustomer = ( email: string | null | undefined ) => {
  if ( !email || !window.dataLayer ) {
    return;
  }

  window.dataLayer.push({ event: 'customer_identified', customer_email: email });
};

export interface IDataLayerCartSource {
  id: number;
  subcarts: Array<{
    cartItems: Array<{
      dataForAnalytics?: IItemDataForAnalytics;
    }>;
  }>;
}

export interface IDataLayerItem {
  // eslint-disable-next-line camelcase
  product_id: string;
  sku: string;
  name: string;
  category: string | null;
  price: number;
  quantity: number;
  url: string | null;
  // eslint-disable-next-line camelcase
  image_url: string | null;
  // eslint-disable-next-line camelcase
  row_total: number;
}

const roundToCents = ( amount: number ) => Math.round( amount * 100 ) / 100;

const toItem = ( data: IItemDataForAnalytics ): IDataLayerItem => ({
  product_id: data.productId,
  sku: data.sku,
  name: data.name,
  category: data.category ?? null,
  price: data.price,
  quantity: data.quantity,
  url: data.url ?? null,
  image_url: data.imageUrl ?? null,
  row_total: roundToCents( data.price * data.quantity ),
});

const toCart = ( cart: IDataLayerCartSource ) => {
  const items = cart.subcarts
    .flatMap(( subcart ) => subcart.cartItems )
    .filter(( cartItem ) => cartItem.dataForAnalytics )
    .map(( cartItem ) => toItem( cartItem.dataForAnalytics ));

  return {
    checkout_id: String( cart.id ),
    value: roundToCents( items.reduce(( total, item ) => total + item.row_total, 0 )),
    items,
  };
};

const productAdded = ( item: IItemDataForAnalytics, cart: IDataLayerCartSource ) => {
  if ( !window.dataLayer ) {
    return;
  }

  window.dataLayer.push({ event: 'product_added', item: toItem( item ), cart: toCart( cart ) });
};

const checkoutStarted = ( cart: IDataLayerCartSource ) => {
  if ( !window.dataLayer ) {
    return;
  }

  window.dataLayer.push({ event: 'checkout_started', ...toCart( cart ) });
};

export default {
  checkoutStarted,
  identifyCustomer,
  productAdded,
};
